export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  image: string;
  category: string;
  categoryColor: string;
  date: string;
  dateISO: string;
  readTime: string;
  tags: string[];
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: 'AVCB: Guia Completo para Regularização da sua Empresa',
    slug: 'avcb-completo-guia',
    excerpt:
      'Entenda tudo sobre o Auto de Vistoria do Corpo de Bombeiros, documentação necessária, prazos e como regularizar seu estabelecimento em Sorocaba e Campinas.',
    image:
      'https://public.readdy.ai/ai/img_res/40a2279b555aaa477f5cdd79fcb924d1.jpg',
    category: 'AVCB',
    categoryColor: 'bg-red-600',
    date: '20 de Fevereiro de 2026',
    dateISO: '2026-02-20',
    readTime: '8 min',
    tags: ['AVCB', 'Prevenção de Incêndio', 'Regularização', 'Sorocaba', 'Campinas'],
  },
  {
    id: 2,
    title: 'CLCB: Entenda a Licença Provisória do Corpo de Bombeiros',
    slug: 'clcb-licenca-bombeiros',
    excerpt:
      'Saiba quando solicitar o CLCB, diferenças para o AVCB, documentação necessária e como fazer a conversão para o certificado definitivo.',
    image:
      'https://readdy.ai/api/search-image?query=business%20professional%20reviewing%20fire%20safety%20documents%20and%20certificates%20on%20desk%20with%20laptop%20in%20modern%20office%20setting%20with%20clean%20organized%20workspace%20bright%20natural%20lighting%20minimalist%20corporate%20style%20with%20white%20background&width=800&height=500&seq=blog2&orientation=landscape',
    category: 'CLCB',
    categoryColor: 'bg-orange-600',
    date: '14 de Fevereiro de 2026',
    dateISO: '2026-02-14',
    readTime: '7 min',
    tags: ['CLCB', 'Licença Provisória', 'Corpo de Bombeiros', 'Regularização'],
  },
  {
    id: 3,
    title: 'Segurança do Trabalho: Documentos Obrigatórios para sua Empresa',
    slug: 'seguranca-trabalho-empresas',
    excerpt:
      'Conheça o PGR, LTCAT, PCMSO e outros documentos essenciais de segurança do trabalho que sua empresa precisa ter em dia para evitar multas e proteger seus colaboradores.',
    image:
      'https://readdy.ai/api/search-image?query=industrial%20workers%20wearing%20safety%20equipment%20helmets%20and%20protective%20gear%20in%20modern%20factory%20setting%20with%20safety%20signs%20and%20organized%20workspace%20bright%20professional%20environment%20emphasizing%20workplace%20safety%20culture%20with%20white%20background&width=800&height=500&seq=blog3&orientation=landscape',
    category: 'Segurança do Trabalho',
    categoryColor: 'bg-blue-600',
    date: '07 de Fevereiro de 2026',
    dateISO: '2026-02-07',
    readTime: '10 min',
    tags: ['Segurança do Trabalho', 'PGR', 'LTCAT', 'NR', 'Documentação'],
  },
  {
    id: 4,
    slug: 'pericias-tecnicas-engenheiro-processos-judiciais',
    title: 'Perícias Técnicas: O Papel do Engenheiro em Processos Judiciais',
    category: 'Avaliações e Perícias',
    categoryColor: 'bg-teal-600',
    excerpt: 'Entenda como funciona o trabalho pericial em processos judiciais, a importância da imparcialidade técnica e os principais tipos de perícias realizadas por engenheiros especializados.',
    date: '01 de Fevereiro de 2026',
    dateISO: '2026-02-01',
    readTime: '9 min',
    tags: ['Perícia', 'Judicial', 'Engenheiro Perito', 'Laudo'],
    image: 'https://readdy.ai/api/search-image?query=engineering%20expert%20witness%20professional%20engineer%20examining%20building%20structure%20with%20technical%20equipment%20modern%20construction%20site%20clean%20professional%20environment%20technical%20documentation%20corporate%20photography&width=800&height=500&seq=blog4&orientation=landscape',
  },
  {
    id: 5,
    slug: 'laudos-eletricos-quando-necessarios',
    title: 'Laudos Elétricos: Quando São Necessários e Como São Elaborados',
    category: 'Prevenção de Incêndio',
    categoryColor: 'bg-red-500',
    excerpt: 'Saiba quando sua empresa precisa de laudos elétricos, quais são os tipos mais comuns, como é feita a inspeção técnica e a importância desses documentos para a segurança predial.',
    date: '24 de Janeiro de 2026',
    dateISO: '2026-01-24',
    readTime: '7 min',
    tags: ['Laudo Elétrico', 'NR-10', 'Inspeção', 'Segurança Predial'],
    image: 'https://readdy.ai/api/search-image?query=electrical%20inspection%20report%20professional%20engineer%20with%20testing%20equipment%20examining%20electrical%20panel%20modern%20industrial%20setting%20clean%20technical%20environment%20safety%20equipment%20professional%20corporate%20photography&width=800&height=500&seq=blog5&orientation=landscape',
  },
  {
    id: 6,
    slug: 'nr-10-seguranca-instalacoes-eletricas',
    title: 'NR-10: Guia Completo sobre Segurança em Instalações Elétricas',
    category: 'Segurança do Trabalho',
    categoryColor: 'bg-amber-500',
    excerpt: 'Conheça todos os requisitos da NR-10, as obrigações legais das empresas, os treinamentos necessários e como implementar um programa eficaz de segurança elétrica.',
    date: '17 de Janeiro de 2026',
    dateISO: '2026-01-17',
    readTime: '10 min',
    tags: ['NR-10', 'Elétrica', 'Treinamento', 'Segurança'],
    image: 'https://readdy.ai/api/search-image?query=electrical%20safety%20equipment%20professional%20electrician%20with%20safety%20gear%20modern%20industrial%20facility%20clean%20organized%20technical%20environment%20high%20voltage%20panels%20professional%20lighting%20corporate%20photography&width=800&height=500&seq=blog6&orientation=landscape',
  },
  {
    id: 7,
    slug: 'brigada-incendio-como-formar-treinar',
    title: 'Brigada de Incêndio: Como Formar e Treinar sua Equipe de Emergência',
    category: 'Prevenção de Incêndio',
    categoryColor: 'bg-red-500',
    excerpt: 'Saiba como montar uma brigada de incêndio eficiente na sua empresa, quais são os requisitos legais, os tipos de treinamento obrigatórios e como manter a equipe sempre preparada.',
    date: '10 de Janeiro de 2026',
    dateISO: '2026-01-10',
    readTime: '9 min',
    tags: ['Brigada de Incêndio', 'Treinamento', 'Emergência', 'AVCB'],
    image: 'https://readdy.ai/api/search-image?query=fire%20brigade%20training%20team%20professional%20firefighters%20practicing%20emergency%20evacuation%20procedures%20modern%20corporate%20building%20clean%20organized%20safety%20drill%20professional%20photography%20warm%20lighting&width=800&height=500&seq=blog7&orientation=landscape',
  },
  {
    id: 8,
    slug: 'insalubridade-periculosidade-diferencas',
    title: 'Insalubridade e Periculosidade: Diferenças, Laudos e Direitos do Trabalhador',
    category: 'Segurança do Trabalho',
    categoryColor: 'bg-amber-500',
    excerpt: 'Entenda as diferenças entre insalubridade e periculosidade, como são elaborados os laudos técnicos, quais são os adicionais devidos e os direitos garantidos ao trabalhador.',
    date: '05 de Janeiro de 2026',
    dateISO: '2026-01-05',
    readTime: '13 min',
    tags: ['Insalubridade', 'Periculosidade', 'Laudo', 'Direitos'],
    image: 'https://readdy.ai/api/search-image?query=occupational%20safety%20engineer%20evaluating%20hazardous%20work%20conditions%20industrial%20environment%20professional%20assessment%20technical%20equipment%20clean%20organized%20workspace%20safety%20documentation%20corporate%20photography&width=800&height=500&seq=blog8&orientation=landscape',
  },
  {
    id: 9,
    slug: 'avaliacao-imoveis-engenharia-diagnostico',
    title: 'Avaliação de Imóveis por Engenharia: Diagnóstico Técnico e Valoração',
    category: 'Avaliações e Perícias',
    categoryColor: 'bg-teal-600',
    excerpt: 'Conheça o processo de avaliação técnica de imóveis realizado por engenheiros, os métodos utilizados, a importância do laudo de avaliação e quando contratar esse serviço.',
    date: '02 de Janeiro de 2026',
    dateISO: '2026-01-02',
    readTime: '8 min',
    tags: ['Avaliação de Imóveis', 'Laudo', 'Engenharia', 'Valoração'],
    image: 'https://readdy.ai/api/search-image?query=professional%20engineer%20appraising%20modern%20building%20property%20evaluation%20technical%20inspection%20clean%20organized%20environment%20architectural%20assessment%20documentation%20corporate%20professional%20photography%20natural%20lighting&width=800&height=500&seq=blog9&orientation=landscape',
  },
  {
    id: 10,
    title: 'NR-23: Tudo sobre Proteção Contra Incêndio nas Empresas',
    slug: 'nr-23-protecao-contra-incendio',
    excerpt:
      'Entenda os requisitos da NR-23, as obrigações das empresas em relação à proteção contra incêndio, equipamentos exigidos e como adequar seu estabelecimento em Sorocaba e Campinas.',
    image:
      'https://readdy.ai/api/search-image?query=fire%20protection%20equipment%20fire%20extinguisher%20sprinkler%20system%20emergency%20exit%20signs%20modern%20industrial%20facility%20clean%20professional%20environment%20safety%20compliance%20theme%20red%20and%20white%20accents%20bright%20lighting&width=800&height=500&seq=blog10&orientation=landscape',
    category: 'Prevenção de Incêndio',
    categoryColor: 'bg-red-600',
    date: '15 de Março de 2026',
    dateISO: '2026-03-15',
    readTime: '9 min',
    tags: ['NR-23', 'Proteção Contra Incêndio', 'Segurança', 'Sorocaba', 'Campinas'],
  },
  {
    id: 11,
    title: 'Laudo de Vistoria Predial: O que é, Quando Fazer e Como Funciona',
    slug: 'laudo-vistoria-predial',
    excerpt:
      'Saiba o que é o laudo de vistoria predial, quando ele é obrigatório, quais elementos são avaliados e como esse documento protege proprietários, inquilinos e condomínios.',
    image:
      'https://readdy.ai/api/search-image?query=professional%20engineer%20conducting%20building%20inspection%20with%20clipboard%20and%20technical%20equipment%20modern%20residential%20building%20facade%20structural%20assessment%20clean%20organized%20environment%20corporate%20photography%20natural%20lighting&width=800&height=500&seq=blog11&orientation=landscape',
    category: 'Avaliações e Perícias',
    categoryColor: 'bg-teal-600',
    date: '08 de Março de 2026',
    dateISO: '2026-03-08',
    readTime: '8 min',
    tags: ['Vistoria Predial', 'Laudo Técnico', 'Engenharia', 'Condomínio', 'Sorocaba'],
  },
  {
    id: 12,
    title: 'PPRA vs PGR: Entenda as Diferenças e a Nova Obrigatoriedade',
    slug: 'ppra-vs-pgr-diferencas',
    excerpt:
      'Com a atualização da NR-01, o PPRA foi substituído pelo PGR. Entenda as principais diferenças, o que mudou na prática e como adequar sua empresa à nova legislação.',
    image:
      'https://readdy.ai/api/search-image?query=occupational%20safety%20professional%20reviewing%20risk%20management%20documents%20modern%20office%20environment%20clean%20organized%20workspace%20safety%20compliance%20documentation%20corporate%20photography%20bright%20natural%20lighting&width=800&height=500&seq=blog12&orientation=landscape',
    category: 'Segurança do Trabalho',
    categoryColor: 'bg-amber-500',
    date: '01 de Março de 2026',
    dateISO: '2026-03-01',
    readTime: '10 min',
    tags: ['PPRA', 'PGR', 'NR-01', 'Segurança do Trabalho', 'Campinas'],
  },
  {
    id: 13,
    title: 'Treinamento NR-35: Trabalho em Altura com Segurança',
    slug: 'treinamento-nr-35-trabalho-em-altura',
    excerpt:
      'Conheça os requisitos do treinamento NR-35, quem é obrigado a realizá-lo, carga horária, conteúdo programático e como a Engeporto capacita equipes em Sorocaba e Campinas.',
    image:
      'https://readdy.ai/api/search-image?query=worker%20wearing%20safety%20harness%20working%20at%20height%20on%20industrial%20structure%20professional%20safety%20training%20equipment%20modern%20construction%20site%20clean%20organized%20environment%20safety%20compliance%20photography&width=800&height=500&seq=blog13&orientation=landscape',
    category: 'Treinamentos',
    categoryColor: 'bg-green-600',
    date: '22 de Fevereiro de 2026',
    dateISO: '2026-02-22',
    readTime: '8 min',
    tags: ['NR-35', 'Trabalho em Altura', 'Treinamento', 'Sorocaba', 'Campinas'],
  },
  {
    id: 14,
    title: 'Manutenção de Extintores: Prazos, Normas e Obrigações Legais',
    slug: 'manutencao-extintores-normas',
    excerpt:
      'Entenda a importância da manutenção periódica de extintores, os prazos exigidos pela ABNT NBR 12962, tipos de manutenção e as consequências de manter extintores irregulares.',
    image:
      'https://readdy.ai/api/search-image?query=fire%20extinguisher%20maintenance%20inspection%20professional%20technician%20checking%20fire%20safety%20equipment%20modern%20industrial%20building%20clean%20organized%20environment%20red%20extinguishers%20safety%20compliance%20corporate%20photography&width=800&height=500&seq=blog14&orientation=landscape',
    category: 'Prevenção de Incêndio',
    categoryColor: 'bg-red-500',
    date: '10 de Março de 2026',
    dateISO: '2026-03-10',
    readTime: '7 min',
    tags: ['Extintores', 'Manutenção', 'ABNT NBR 12962', 'Prevenção de Incêndio', 'Sorocaba'],
  },
  {
    id: 15,
    title: 'Licença Ambiental para Empresas: Tipos, Etapas e Como Obter',
    slug: 'licenca-ambiental-empresas',
    excerpt:
      'Saiba quais empresas precisam de licença ambiental, os tipos de licença (LP, LI, LO), o processo de licenciamento e como a regularização ambiental protege seu negócio em Sorocaba e Campinas.',
    image:
      'https://readdy.ai/api/search-image?query=environmental%20compliance%20professional%20engineer%20reviewing%20environmental%20license%20documents%20modern%20office%20green%20sustainable%20business%20clean%20organized%20workspace%20corporate%20photography%20natural%20lighting%20bright%20environment&width=800&height=500&seq=blog15&orientation=landscape',
    category: 'Meio Ambiente',
    categoryColor: 'bg-emerald-600',
    date: '05 de Março de 2026',
    dateISO: '2026-03-05',
    readTime: '11 min',
    tags: ['Licença Ambiental', 'LP', 'LI', 'LO', 'Meio Ambiente', 'Sorocaba', 'Campinas'],
  },
];

export const categoryCounts: Record<string, number> = blogPosts.reduce(
  (acc, post) => {
    acc[post.category] = (acc[post.category] || 0) + 1;
    return acc;
  },
  {} as Record<string, number>
);
